import React from 'react';
import Paths from './Paths';

function SocialIcons({ width = 24, height = 24, name, ...rest }) {
  const path = Paths?.[name];
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24">
      <g>
        <path d={path} />
      </g>
    </svg>
  );
}

export default SocialIcons;
